// ─── SINGLE SOURCE OF TRUTH FOR BRAND INFO ───
// To rename the company later, change `name` (and `shortName`) here only —
// every page, heading, footer and email reference updates automatically.
export const SITE = {
  name: "Rock Coast Cleaning",
  legalName: "RC Cleaning Inc.",
  shortName: "Rock Coast",
  tagline: "Clean spaces, better places",
  email: "info@rockcoastcleaning.ca",
  phone: "709-730-7888",
  phoneHref: "tel:+17097307888",
  facebook: "https://www.facebook.com/profile.php?id=61593414311913", 
  region: "St. John's & the Avalon, NL",
  replyPromise: "We reply within 24 hours",
  scheduling: "Flexible scheduling available",
};

export const CONFIRMATION_MESSAGE =
  "Thanks for reaching out! We've received your request and will get back to you within 24 hours with your free quote.";

export const SERVICE_TYPES = [
  "Standard Cleaning",
  "Deep Cleaning",
  "Move-In / Move-Out",
  "Post-Construction",
  "Commercial Spaces & Offices",
  "B&B / Airbnb / Short-Term Rental",
  "Airbnb Management",
  "Property Management",
];

export const FREQUENCIES = ["One-Time", "Weekly", "Biweekly", "Monthly"];
